<template>
  <input
    v-if="!disabled"
    aria-label="Поле ввода скидки в тенге"
    type="text"
    v-bind:disabled="disabled"
    v-bind:value="inputValue"
    v-on:blur="onBlur"
    v-on:focus="isFocused = true"
    v-on:input="onInput"
    class="input-discount"
  />
  <span v-else>{{ inputValue }}</span>
</template>

<script>

/**
 * @description Название события вода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса.
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * @description Поле ввода скидки в рублях.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Значение поля.
     * @returns {string}
     */
    inputValue() {
      if (this.isFocused && this.value === 0) {
        return '';
      }
      const value = (this.value / 100).toString();
      if (!this.isFocused && value === '') {
        return '0';
      }
      return value;
    },
  },
  data() {
    return {
      /**
       * @description Фокус на поле.
       * @type {boolean}
       */
      isFocused: false,
    };
  },
  methods: {
    /**
     * @description Отправить событие ввода.
     * @param {number} value
     * @param {boolean} isInvalid
     * @returns {void}
     */
    emitInput(value, isInvalid) {
      this.$emit(NAME_EVENT_INPUT, value);
      if (isInvalid) {
        this.$forceUpdate();
      }
    },
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      this.isFocused = false;
      this.$emit(NAME_EVENT_BLUR);
    },
    /**
     * @description Обработать ввод.
     * @returns {void}
     */
    onInput(event) {
      const regexp = /\D+/g;
      const inputValue = event.target.value;
      const isInvalid = regexp.test(inputValue);
      const value = isInvalid ? inputValue.replace(regexp, '') : inputValue;
      if (value === '') {
        this.emitInput(0, isInvalid);
        return;
      }
      const kop = Number(value) * 100;
      if (kop > this.maxDiscountInKop) {
        this.$forceUpdate();
        return;
      }
      this.emitInput(kop, isInvalid);
    },
  },
  name: 'InputDiscountInRubles',
  props: {
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Максимальное значение скидки в копейках.
     * @type {number}
     */
    maxDiscountInKop: { type: Number, required: true },
    /**
     * @description Значение в копейках.
     * @type {number}
     */
    value: { type: Number, required: true },
  },
};
</script>

<style lang="scss" scoped>
.input-discount {
  padding: 5px 8px;
  border: 1px solid var(--border-color);
  width: 100%;
  &:focus-visible {
    outline-color: var(--action-color);
  }
}
</style>
